
export default function (history, e, link) {

    console.log("e", e, "e.itemData", e.itemData);

    if (e.itemData.path == undefined)
        return;

    const ctrl = e.ctrlKey || e.event?.ctrlKey;
    const alt = e.altKey || e.event?.altKey;

    const path = e.itemData.path;

    console.log("path", path);

    if (ctrl || alt) {
        const features = alt ? "location=on" : undefined;
        const win = window.open(path, "_blank", features);
        win.focus();

        return;
    }

    history.push(path);
}
